export default __webpack_public_path__ + "static/media/tick-icon.5a4ed112.svg";